module.exports = __webpack_public_path__ + "files/1d6e1e942b0173abbe059f34b9a35cd2.png";